jQuery(document).ready(function ($) {
    const controls = $('.home-hero__controls');
    const video = controls.prev();

    const toggle = controls.find('.home-hero__controls--toggle');
    const restart = controls.find('.home-hero__controls--restart');

    const progress = controls.find('.home-hero__controls--progress');

    let interval = 0;

    $.fn.isPaused = function () {
        return this.get(0).paused;
    }

    $.fn.play = function () {
        this.trigger('play');
        return this;
    }

    $.fn.pause = function () {
        this.trigger('pause');
        return this;
    }

    $.fn.restart = function () {
        this.get(0).currentTime = 0;
        return this.play();
    }

    $.fn.jumpToPercentage = function (percentage) {
        this.get(0).currentTime = (percentage / 100) * this.get(0).duration;
        return this.play();
    }

    function togglePlayback(event) {
        const this_controls = $(this).closest('.home-hero__controls');
        const video = this_controls.prev();

        if (video.isPaused()) {
            $(this).addClass('play');
            video.play();
        }
        else {
            $(this).removeClass('play');
            video.pause();
        }
    }

    toggle.on('click', togglePlayback);

    function jumpBackwards(event) {
        const this_controls = $(this).closest('.home-hero__controls');
        const video = this_controls.prev();

        video.next().find('.home-hero__controls--progress').trigger('restart');

        video.restart();
    }

    restart.on('click', jumpBackwards);

    function initProgressBar(event) {
        const progress = $(this).next().find('.home-hero__controls--progress');
        const elapsed = progress.find('span');

        clearInterval(interval);

        interval = setInterval(function () {
            const current_time = this.currentTime / this.duration;
            elapsed.css('width', (current_time * 100) + '%');
        }.bind(this, elapsed), 0.5);
    }

    video.on('play', initProgressBar);

    function restartProgressBar(event) {
        const elapsed = $(this).find('span');
        elapsed.css('width', '0');
    }

    progress.on('restart', restartProgressBar);

    function jumpTo(event) {

        const offset = $(this).offset();
        const width = $(this).width();
        const percentage = ((event.pageX - offset.left) / width) * 100;

        $(this).find('span').css('width', percentage + '%');

        const this_controls = $(this).closest('.home-hero__controls');
        const video = this_controls.prev();

        video.jumpToPercentage(percentage);
    }

    progress.on('click', jumpTo);

    video.play();
});